import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

import { ButtonVariant } from './types';

function getButtonStyle(variant: ButtonVariant): string | undefined {
  switch (variant) {
    case ButtonVariant.link:
      return styles.link;

    case ButtonVariant.primary:
      return styles.primary;

    case ButtonVariant.secondary_light:
      return styles.secondaryLight;
  }
}

type ButtonProps = {
  variant: ButtonVariant;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function Button({
  variant,
  children,
  className,
  ...buttonProps
}: ButtonProps) {
  return (
    <button
      className={classnames(styles.base, getButtonStyle(variant), className)}
      {...buttonProps}
    >
      {children}
    </button>
  );
}
